import { Injectable } from '@angular/core';
/*import { SiteSettings } from './../../models/sitesettings.model';*/
import { MainService } from 'src/app/services/api/main.service';

@Injectable({
	providedIn: 'root'
})
export class SettingsService {

	settings: any = {};

	/** 
	 * this variable is used to check if the css for catalog page
	 * if the items was already added of not
	 * this is used on catalog.component.ts
	 */
	cssAdded: boolean = false;

	constructor(
		public mainService: MainService
	) {
		this.set();
	}

	set(){
		this.getConfig('/rest/entrelable/V1/lns-sociallogin/config', 'social_login');
		this.getConfig('/rest/entrelable/V1/lns-entrelabel/config/site/setting', 'site_settings');
		let data = {
			email: 'hello@entrelabel.ph',
			contact: '(+639) 000 0000'
		}
		this.settings = data;
	}

	getConfig(url, configName: string){
		if(!this.settings[configName]){
			this.mainService.get(url)
			.subscribe(result => {
				this.settings[configName] = result[0];
			}, error => this.mainService.errorHandler(error) );
		}
	}

	getConfigPromise(url, configName: string){
		return new Promise(config => {
			if(!this.settings[configName]){

				this.mainService.get(url).subscribe(result => {
				this.settings[configName] = result[0];
					config(this.settings[configName]);
				}, error => {
					config(null);
				});

			} else {
				config(this.settings[configName]);
			}
		});
	}
}
